module.exports = __webpack_public_path__ + "build/img/connexions_250.02407ee0.png";